import(/* webpackMode: "eager", webpackExports: ["message","error"] */ "__barrel_optimize__?names=message!=!/apps/client-help-ssr/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/apps/client-help-ssr/node_modules/jotai/esm/react.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/apps/client-help-ssr/src/app/[lang]/help/Index.tsx");
